/* eslint-disable no-unsafe-optional-chaining */

import { useRouter } from "next/router"
import Accordion from "react-bootstrap/Accordion"
import { Image, RatioImage } from "@components/anti/Image"
import Link from "@components/anti/Link"
import {
  dataLayerClickBurgerMenu,
  dataLayerClickSosmedMenu,
} from "lib/datalayer"
import {
  linkAbout,
  linkContactUs,
  linkGovernanceAgms,
  linkInvestorProspectus,
  linkLocations,
  linkOurCommitment,
  linkProductsServices,
} from "src/helper/page-url"
import { translations } from "src/helper/translations"
import { useGeneralStore } from "store"

export function MobileMenuMain({ showMenu, setShowMenu, handleClickMenu }) {
  const Router = useRouter()
  const { pathname, asPath, query, locale } = Router
  const { navbarData, footerData } = useGeneralStore()
  const listSocial = [
    {
      type: "instagram",
      link: footerData?.instagram_url,
    },
    {
      type: "x",
      link: footerData?.twitter_url,
    },
    {
      type: "facebook",
      link: footerData?.facebook_url,
    },
    {
      type: "youtube",
      link: footerData?.youtube_url,
    },
  ]
  const listMenu = [
    {
      title: translations[`about_${locale}`],
      slug: linkAbout,
      type: "link",
    },
    {
      title: translations[`product_services_${locale}`],
      slug: linkProductsServices,
      type: "dropdown",
    },
    {
      title: translations[`governance_${locale}`],
      slug: linkGovernanceAgms,
      type: "link",
    },
    {
      title: translations[`investors_area_${locale}`],
      slug: linkInvestorProspectus,
      type: "link",
    },
    {
      title: translations[`our_commitment_${locale}`],
      slug: linkOurCommitment,
      type: "link",
    },
    {
      title: translations[`contact_us_${locale}`],
      slug: linkContactUs,
      type: "link",
    },
  ]

  const listSecondMenu = [
    {
      title: translations[`now_playing_${locale}`],
      slug: footerData?.now_playing_url,
      type: "link",
      target: "_blank",
    },
    {
      title: translations[`find_cinema_${locale}`],
      slug: linkLocations,
      type: "link",
      target: "",
    },
    {
      title: translations[`download_mtix_${locale}`],
      slug: footerData?.mtix_play_store_url,
      type: "link",
      target: "",
    },
  ]

  return (
    <>
      <div className={`mobile-menu ${showMenu.mainMenu ? "show" : ""}`}>
        <div className="mobile-menu__content container">
          <div className="mobile-menu-top">
            <div className="language-wrapper">
              {/* <div className="container"> */}
              <button
                className={`language-switcher en ${
                  locale === "en" ? "active" : ""
                }`}
                onClick={() => {
                  // window.location.href = `/en${Router.asPath}`
                  Router.push({ pathname, query }, asPath, {
                    locale: "en",
                    scroll: false,
                  })
                }}
              >
                en
              </button>
              <button
                className={`language-switcher id ${
                  locale === "id" ? "active" : ""
                }`}
                onClick={() => {
                  // window.location.href = `/id${Router.asPath}`
                  Router.push({ pathname, query }, asPath, {
                    locale: "id",
                    scroll: false,
                  })
                }}
              >
                id
              </button>
              {/* </div> */}
            </div>
            <button
              className="close-btn"
              onClick={() =>
                setShowMenu((prev) => ({ ...prev, mainMenu: false }))
              }
            >
              <Image
                src="/img/icon/img_icon-close.svg"
                className="img-close img-fluid"
                alt="img-close"
                fill
              />
            </button>
          </div>
          <div className="mobile-menu-nav">
            {listMenu?.map((item, i) => (
              <div
                className="mobile-menu-nav_item"
                key={`mobile-menu-nav_item__${i}`}
                onClick={() => {
                  dataLayerClickBurgerMenu({ menu_name: item.title })
                  handleClickMenu(item)
                }}
                role="presentation"
              >
                <span
                  className={
                    showMenu.mainMenu
                      ? `slideInUp d${i + 3}`
                      : `fadeOutUp d${i}`
                  }
                >
                  {item.title}
                  {item.type === "dropdown" && (
                    <i className="air ai-arrow-right ml-2 mt-2" />
                  )}
                </span>
              </div>
            ))}
          </div>
          <div className="mobile-menu-bottom">
            <ul className="mobile-menu-link_list">
              {listSecondMenu.map((item, i) => (
                <li className="mobile-menu-link_item" key={i}>
                  <div
                    className={`${
                      showMenu.mainMenu
                        ? `slideInUp d${7 + i}`
                        : `fadeOutUp d${4}`
                    }`}
                    onClick={() => {
                      handleClickMenu(item)
                    }}
                    role="presentation"
                  >
                    {item.title} <i className="cxi-chevron-right ml-1" />
                  </div>
                </li>
              ))}
            </ul>
            <ul className="mobile-menu-social_list">
              {listSocial.map((item, i) => (
                <li
                  className={`mobile-menu-social_item ${
                    showMenu.mainMenu
                      ? `slideInUp d${i + 7}`
                      : `fadeOutUp d${i + 4}`
                  }`}
                  key={`mobile-menu-social_item__${i}`}
                  onClick={() => {
                    dataLayerClickSosmedMenu({ "social media": item.type })
                    handleClickMenu(item)
                  }}
                  role="presentation"
                >
                  <i className={`aib ai-${item.type}`} />
                </li>
              ))}
            </ul>
          </div>
          <div className="vector-asset">
            <Image
              src="/img/brand/img_brand-mobile-nav.png"
              width={360}
              height={494}
              // fill
              alt="vector"
            />
          </div>
          <div className="vector-asset w-100 h-100">
            <Image
              src="/img/misc/img_misc-mobile-menu.png"
              // width={360}
              // height={672}
              fill
              className="w-100"
              alt="gradient"
            />
          </div>
        </div>
      </div>
      <ProductsMenu
        showMenu={showMenu.subMenu}
        setShowMenu={setShowMenu}
        menuList={navbarData}
        handleClickMenu={handleClickMenu}
        locale={locale}
      />
    </>
  )
}

export function ProductsMenu({
  showMenu,
  setShowMenu,
  handleClickMenu,
  menuList,
  locale,
}) {
  return (
    <div className={`mobile-menu ${showMenu ? "show" : ""}`}>
      <div className="mobile-menu__content container">
        <div className="mobile-menu-top justify-content-end">
          <button
            className="close-btn"
            onClick={() =>
              setShowMenu((prev) => ({ subMenu: false, mainMenu: false }))
            }
          >
            <Image
              src="/img/icon/img_icon-close.svg"
              className="img-close img-fluid"
              alt="img-close"
              fill
            />
          </button>
        </div>
        <div className="mobile-menu-nav sub w-100">
          <button
            className="back-btn"
            onClick={() => setShowMenu((prev) => ({ ...prev, subMenu: false }))}
          >
            <i className="air ai-arrow-left mr-3" />{" "}
            {locale === "en" ? "Back" : "Kembali"}
          </button>
          <div
            className="mobile-menu-nav_item mb-0"
            onClick={() => handleClickMenu({ slug: linkProductsServices })}
            role="presentation"
          >
            <span className={showMenu ? `slideInUp d${3}` : `fadeOutUp d${1}`}>
              {translations[`product_services_${locale}`]}
              <i className="air ai-arrow-right ml-2" />
            </span>
          </div>
          <div className="bottom-line my-4" />
          <div className="mobile-menu-accordion">
            <Accordion defaultActiveKey={0}>
              {menuList
                ?.filter((item) => item.list)
                .map((item, i) => (
                  <Accordion.Item
                    eventKey={i}
                    className={`overflow-hidden ${
                      showMenu ? `fadeInUp d${i + 7}` : `fadeOutUp d${i + 4}`
                    }`}
                    key={`mobile-accordion-${i}`}
                  >
                    <Accordion.Header>
                      <span>{item.title}</span>
                      <i className="air ai-angle-down" />
                    </Accordion.Header>
                    <Accordion.Body>
                      <ul className="accordion-list">
                        {item.list?.map((itemChild, indexChild) => (
                          <li
                            key={`mobile-accordion-children__item-${indexChild}`}
                            className="accordion-item"
                            onClick={() => handleClickMenu(itemChild)}
                            role="presentation"
                          >
                            {itemChild.title}
                          </li>
                        ))}
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
            </Accordion>
            <div
              className={`mobile-menu__item overflow-hidden ${
                showMenu
                  ? `fadeInUp d${menuList?.length + 7}`
                  : `fadeOutUp d${menuList?.length + 4}`
              }`}
            >
              {menuList
                ?.filter((item) => !item.list)
                .map((item, i) => (
                  <span
                    className={`mobile-menu__item-nav ${
                      showMenu
                        ? `fadeInUp d${i + menuList?.length + 7}`
                        : `fadeOutUp d${i + menuList?.length + 4}`
                    }`}
                    key={`mobile-menu__item-nav-${item?.title}`}
                    onClick={() => handleClickMenu(item)}
                    role="presentation"
                  >
                    {item.title}
                  </span>
                ))}
            </div>
          </div>
        </div>
        <div className="vector-asset">
          <Image
            src="/img/brand/img_brand-mobile-nav.png"
            width={360}
            height={494}
            alt="vector"
          />
        </div>
        <div className="vector-asset w-100 h-100">
          <Image
            src="/img/misc/img_misc-mobile-menu.png"
            fill
            className="w-100"
            alt="gradient"
          />
        </div>
      </div>
    </div>
  )
}
